export enum MessageTypeEnum {
  email = 1,
  sms = 2,
  emailab = 3,
  'rcs-text' = 4,
  'rcs-rich-card' = 5,
  'rcs-carousel' = 6
}
